import { get, postForm } from "api/http"
import { sendSMSURL, loginURL, logoutURL } from "api/urls"
import { toast } from "react-toastify"

export const clearAuthenticated = () => {
  return {
    type: "CLEAR_AUTHENTICATED",
  }
}

export const storeIntent = (type, payload) => {
  return {
    type: "STORE_INTENT",
    payload: { type, payload },
  }
}

export const clearIntent = () => {
  return {
    type: "CLEAR_INTENT",
  }
}

// SEND_SMS

export const sendSMSStart = () => ({
  type: "SEND_SMS_START",
})

export const sendSMSSuccess = (payload) => ({
  type: "SEND_SMS_SUCCESS",
  payload,
})

export const sendSMSError = (payload) => ({
  type: "SEND_SMS_ERROR",
  payload,
})

export const sendSMS = (phone, captcha) => async (dispatch, getState) => {
  const body = {
    phone,
    captcha
  }

  try {
    dispatch(sendSMSStart())
    const response = await postForm(sendSMSURL(), { body })
    const json = await response.json()

    if (response.status === 200 || response.status === 201) {
      if (json.status !== "error") {
        dispatch(sendSMSSuccess(json))
        if (json.status === "warning") {
          toast.info(json.reason, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
          })
        } else {
          toast.info("SMS sporočilo je bilo poslano.", {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
          })
        }
      } else {
        dispatch(sendSMSError(json))
        toast.error(json.reason, {
          position: toast.POSITION.BOTTOM_CENTER,
          hideProgressBar: true,
        })
      }
    } else {
      if (response.status === 403) {
        dispatch(clearAuthenticated())
      }

      dispatch(sendSMSError(json))
    }
  } catch (e) {
    dispatch(sendSMSError(e))
  }
}

// SEND_PIN

export const sendPINStart = (payload) => ({
  type: "SEND_PIN_START",
  payload,
})

export const sendPINSuccess = (payload) => ({
  type: "SEND_PIN_SUCCESS",
  payload,
})

export const sendPINError = (payload) => ({
  type: "SEND_PIN_ERROR",
  payload,
})

export const sendPIN = (phone, pin) => async (dispatch, getState) => {
  const body = {
    phone,
    pin,
  }

  try {
    dispatch(sendPINStart(body))
    const response = await postForm(loginURL(), { body })
    const json = await response.json()

    if (response.status === 200 || response.status === 201) {
      dispatch(sendPINSuccess(json))
    } else {
      if (response.status === 403) {
        dispatch(clearAuthenticated())
      }
      dispatch(sendPINError(json))
      toast.error(json.reason, {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
      })
    }
  } catch (e) {
    dispatch(sendPINError(e))
  }
}

// LOG OUT

export const logOutStart = (payload) => ({
  type: "LOGOUT_START",
  payload,
})

export const logOutSuccess = (payload) => ({
  type: "LOGOUT_SUCCESS",
  payload,
})

export const logOutError = (payload) => ({
  type: "LOGOUT_ERROR",
  payload,
})

export const logOut = () => async (dispatch, getState) => {
  try {
    dispatch(logOutStart())
    const response = await get(logoutURL())

    if (response.status === 200) {
      dispatch(logOutSuccess())
    } else {
      if (response.status === 403) {
        dispatch(clearAuthenticated())
      }

      dispatch(logOutError())
    }
  } catch (e) {
    dispatch(logOutError(e))
  }
}
